import { request } from './request'

// 获取分组列表
export interface GetGroupData {
  name?: string
}
export const getGroup = (data: GetGroupData) =>
  request('/portal/verify/phish/campaign/group/list', {
    params: {
      ...data,
    },
  })

// 获取部门列表
export interface GetGroupList {
  name?: string
}
export const getGroupList = (data: GetGroupList) =>
  request('/portal/verify/phish/contacts/groupList', {
    params: {
      ...data,
    },
  })
// 删除用户分组
export interface DeleteGroupData {
  ids: string[]
}

export const deleteGroup = (data: DeleteGroupData) =>
  request('/portal/verify/phish/contacts/group', {
    method: 'DELETE',
    data,
  })

// 新增用户分组
export interface AddGroupData {
  name: string
}
export const addGroup = (data: AddGroupData) =>
  request('/portal/verify/phish/contacts/group', {
    method: 'post',
    data,
  })

// 修改分组名字
export interface EditGroupData {
  id: string
  name: string
}
export const editGroup = (data: EditGroupData) =>
  request('/portal/verify/phish/contacts/group', {
    method: 'put',
    data,
  })
// 新增用户
export interface AddTarget {
  targets: {
    email: string
    name: string
    group_id: number
    dept_name: string
    tag_ids: number
  }[]
}
export const addTarget = (data: AddTarget) =>
  request('/portal/verify/phish/contacts/target', {
    method: 'post',
    data,
  })
//获取最近任务列表
export interface GetTargetList {
  page: number
  limit: number
  email_keyword?: string
  group_id?: string
  name_keyword?: string
  end_time?: string
  start_time?: string
  tag_ids?: string[]
  item?: string
  group_keyword?: string
  aware?: string //（优秀/良好/较差/差）
  /**邮箱来源 */
  origin_from?: number
}
export const getTargetList = (data: GetTargetList) =>
  request('/portal/verify/phish/contacts/targetList', {
    method: 'POST',
    data,
  })

// 批量删除邮件
export interface DeleteEmailData {
  ids: number[]
}
export const deleteEmail = (data: DeleteEmailData) =>
  request('/portal/verify/phish/contacts/targetList', {
    method: 'DELETE',
    data,
  })

export interface SaveEmailData {
  id: number
  name: string
  dept_name: string
  email: string
  origin_from?: string
}
// /phishapi/targets/update
export const saveEmail = (data: SaveEmailData) =>
  request('/portal/verify/phish/contacts/target', {
    method: 'put',
    data,
  })

// 批量转移
export interface BatchGroupCopyData {
  ids: number[]
  group_id: number
}
export const batchGroupCopy = (data: BatchGroupCopyData) =>
  request('/portal/verify/phish/contacts/target/group', {
    method: 'put',
    data,
  })
// 批量导入
export interface Loadscv {
  group_id: number
  del: number[]
  add: {}[]
  update: {}[]
}
export const loadscv = (data: Loadscv) =>
  request('/portal/verify/phish/contacts/dealcsv', {
    method: 'post',
    data,
  })

//更新邮件账号
export interface UpAuto {
  id: number
}
export const upAuto = (data: UpAuto) =>
  request('/portal/verify/phish/contacts/auto', {
    method: 'post',
    data,
  })

//查询标签

export const getTagList = () => request('/portal/verify/phish/contacts/tagList')

//批量追加邮箱
export interface PutAppend {
  ids: number[]
  tag_ids: number[]
}
export const putAppend = (data: PutAppend) =>
  request('/portal/verify/phish/contacts/target/tag/append', {
    method: 'put',
    data,
  })
//批量覆盖邮箱tag
export const putTag = (data: PutAppend) =>
  request('/portal/verify/phish/contacts/target/tag', {
    method: 'put',
    data,
  })
//修改邮箱名称
export interface PutName {
  id: string
  name: string
}
export const putName = (data: PutName) =>
  request('/portal/verify/phish/contacts/target/name', {
    method: 'put',
    data,
  })
//批量新增标签
export interface PostName {
  name_list: string[]
}
export const postName = (data: PostName) =>
  request('/portal/verify/phish/contacts/tag', {
    method: 'POST',
    data,
  })
//删除标签
export interface DeleteTag {
  id: number
}
export const deleteTag = (data: DeleteTag) =>
  request('/portal/verify/phish/contacts/tag', {
    method: 'delete',
    data,
  })
//修改标签
export interface PutContactsTag {
  id: number
  name: string
}
export const putContactsTag = (data: PutContactsTag) =>
  request('/portal/verify/phish/contacts/tag', {
    method: 'PUT',
    data,
  })
//获取最近任务列表
export interface GetTask {
  group_id: string
}
export const getTask = (data: GetTask) =>
  request('/portal/verify/phish/contacts/group/task', {
    params: {
      ...data,
    },
  })
//获取部门最近十次任务趋势图
export const getTaskChart = (data: GetTask) =>
  request('/portal/verify/phish/contacts/group/task/chart', {
    params: {
      ...data,
    },
  })

//获取有任务的部门列表
export const getGroupListOrderAware = () =>
  request('/portal/verify/phish/contacts/groupListOrderAware', {})

export const getCsv = () =>
  request('/portal/verify/waf/resource/template/payloads/download/csv', {})

// 获取公司评分图表信息
export const getChart = () => request('/portal/verify/phish/contacts/group/chart', {})
// 获取可添加邮箱域名
export const getDomain = () => request('/portal/verify/phish/contacts/target/domain', {})
// 获取评估目标数量
export const getTotal = () => request('/portal/verify/phish/contacts/target/total')
// 根据邮箱获取任务统计数量
export interface GetCount {
  email: string
}
export const getCount = (data: GetCount) =>
  request('/portal/verify/phish/contacts/target/count', { params: data })
// 根据邮箱获取任务统计趋势
export const getTrend = (data: GetCount) =>
  request('/portal/verify/phish/contacts/target/trend', { params: data })
